export default __webpack_public_path__ + "static/media/quiz_bg_mobile.b65aa50a.png";